<template>
  <div class="fee-item-wrapper" :class="{'has-border': hasBorder}">
    <p class="label-txt">
      <RichText :text="label"/>
    </p>
    <p class="value-txt">
      <RichText
        class="value-txt-item"
        v-for="(item, index) in value"
        :key="index"
        :text="item"
      />
    </p>
  </div>
</template>
<script>
import RichText from '@/components/RichText'
export default {
  name: 'FeeItem',
  components: {
    RichText,
  },
  props: {
    label: String,
    value: Array,
    hasBorder: Boolean,
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
.fee-item-wrapper {
  .label-txt .line span {
    font-family: 'Aspira Light'!important;
    font-weight: 200 !important;
    // font-size: 16px !important;
  }
  .value-txt .value-txt-item span {
    font-family: 'Aspira Medium' !important;
    font-weight: 500 !important;
    // font-size: 16px !important;
    word-break: break-all;
    word-wrap: break-word;
  }
  .value-txt .line {
    margin-bottom: 6px !important;
  }
}
</style>
<style lang="scss" scoped>
.fee-item-wrapper {
  display: flex;
  margin-bottom: 20px;
  overflow: hidden;
}
.has-border {
  height: 0;
  border-bottom: 1px solid #E5E5E5;
}
.label-txt {
  flex: 1;
  width: 150px;
  line-height: 18px;
  font-family: 'Aspira Light';
  font-size: 16px;
  color: #000000;
}
.value-txt {
  margin-left: 8px;
  text-align: right;
  font-size: 0;
}
.value-txt-item {
  width: 171px;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  word-wrap: break-word;
}
@media screen and (max-width: 768px) {
  .fee-item-wrapper {
    margin-bottom: rem(40);
  }
  .label-txt {
    width: rem(200);
    line-height: rem(36);
    font-size: rem(36);
  }
  .value-txt-item {
    width: rem(340);
  }
}
</style>